import { render, staticRenderFns } from "./TopNavbarNotifications.vue?vue&type=template&id=1ee226ea&scoped=true&"
import script from "./TopNavbarNotifications.vue?vue&type=script&lang=js&"
export * from "./TopNavbarNotifications.vue?vue&type=script&lang=js&"
import style0 from "./TopNavbarNotifications.vue?vue&type=style&index=0&id=1ee226ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee226ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ee226ea')) {
      api.createRecord('1ee226ea', component.options)
    } else {
      api.reload('1ee226ea', component.options)
    }
    module.hot.accept("./TopNavbarNotifications.vue?vue&type=template&id=1ee226ea&scoped=true&", function () {
      api.rerender('1ee226ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/partials/TopNavbarNotifications.vue"
export default component.exports